import config from "../config/config";

import helper from "../helper/helpers";
/* Detect if AB test is setup correctly and is active */
const detectIfValidTest = (page) => {
    const abTest = helper.getABTest(page);
    const setup = abTest[config.gizmoSetupKey];
    const pages = abTest[config.gizmoPagesKey];
    if(!setup || !pages) // AB test found on page
        return false;
    if(!setup.enabled) // Ab Test is enabled
        return false;
    if(!setup.abtests || setup.abtests.length === 0) // Ab Test setup found
        return false;
    if(pages.length === 0) // Ab Test content found
        return false;
    if(pages.length !== setup.abtests.length) // Ab Test setup items does not match with content
        return false;
    if(!setup.testDateTo || !setup.testDateFrom) // Test dates not set
        return false;
    try {
        let parsedToDate = new Date(setup.testDateTo);
        let parsedFromDate = new Date(setup.testDateFrom);
        let currentDate = new Date();
        if(parsedToDate.toString() === "Invalid Date")
            return false;
        if(parsedFromDate.toString() === "Invalid Date")
            return false;
        let lengthLeft = parsedToDate.getTime() - parsedFromDate.getTime();
        if(!lengthLeft || lengthLeft <= 0) // Valid time period not set up
            return false;
        lengthLeft = parsedToDate.getTime() - currentDate.getTime();
        if(!lengthLeft || lengthLeft <= 0) // AB test is old, time is up!
            return false;
        lengthLeft = parsedFromDate.getTime() - currentDate.getTime();
        if(!lengthLeft || lengthLeft > 0) // AB test has not yet started!
            return false;
    }
    catch (e){
        return false;
    }
    return true; // All good! Lets dance!
};

const getABTestCookie = (id) => {
    const found = localStorage.getItem(`ab-test-${id}`);
    if(found){
        let entry = JSON.parse(found);
        if(new Date(entry.expires) > new Date()){
            return entry.state;
        } else {
            localStorage.removeItem(`ab-test-${id}`);
        }
    }
};

const setABTestCookie = (id, state, expires) => {
    localStorage.setItem(`ab-test-${id}`, JSON.stringify({
        state,
        expires
    }));
};

const getTestPage = (page, overrideIndex) => {
    let pickedPage, pickedIndex;
    const abTest = helper.getABTest(page);

    if(!abTest?.[config.gizmoSetupKey])
        return null;

    const cookieData = (overrideIndex !== undefined) ? overrideIndex : getABTestCookie(abTest[config.gizmoSetupKey].testId);
    if(!isNaN(parseInt(cookieData))) {
        try {
            // Try catched if the editors change numbers of tests after it's been live, and some user have been assigned to something that no longer exists.
            // Do a new pick if that's the case.
            pickedIndex = parseInt(cookieData);
            pickedPage = abTest[config.gizmoPagesKey][cookieData];
        } catch (e) {
            console.log("Could not find page with index from Cookie");
        }
    }
    if(!pickedPage) { // Pick a random page
        let pagesObj = abTest[config.gizmoPagesKey].map((page, index) => {
            return {
                index: index,
                setup: abTest[config.gizmoSetupKey].abtests[index],
                page: page
            }
        })
        let pickedNumber = Math.random();
        let countToPicked = 0;
        let picked = pagesObj.filter(pageObj => {
            let splitValue = pageObj.setup.trafficSplit / 100;
            countToPicked = countToPicked + splitValue;
            return (countToPicked > pickedNumber);
        })[0];
        if(!picked)
            picked = pagesObj[pagesObj.length - 1];

        if(!picked)
            return null;

        pickedPage = picked.page;
        pickedIndex = picked.index;
        if(!cookieData)
            setABTestCookie(abTest[config.gizmoSetupKey].testId, picked.index, page[config.gizmoSetupKey].testDateTo);
    }

    pickedPage[config.vuePageObject] = {
        testIndex: pickedIndex,
        testId: abTest[config.gizmoSetupKey].testId,
        testName: (abTest[config.gizmoSetupKey].insight && abTest[config.gizmoSetupKey].insight.abTestName) ? abTest[config.gizmoSetupKey].insight.abTestName : "Not setup",
        testType: abTest[config.gizmoSetupKey].testType,
        //userId: userId,
        trigger: abTest[config.gizmoSetupKey].abtests[pickedIndex].triggerObject
    };
    return pickedPage;
}

export default {
    detectIfValidTest,
    getTestPage
};